import Dropdown from "../Dropdown/Dropdown";
import GraphConnectionCard from "../GraphConnectionCard/GraphConnectionCard";

function ConversationFiltersPanel({
    graphStatusLoading,
    graphStatusError,
    graphStatus,
    connectingGraph,
    disconnectingGraph,
    onConnectGraph,
    onDisconnectGraph,
    emailFolders,
    phoneFolders,
    selectedFolder,
    onFolderClick,
}) {
    return (
        <div className="crm-conv-filters">
            <GraphConnectionCard
                statusLoading={graphStatusLoading}
                statusError={graphStatusError}
                graphStatus={graphStatus}
                connecting={connectingGraph}
                disconnecting={disconnectingGraph}
                onConnect={onConnectGraph}
                onDisconnect={onDisconnectGraph}
            />
            <Dropdown title="Email">
                <div className="crm-conv-folder-list">
                    {emailFolders.map((folder) => (
                        <button
                            key={folder.id}
                            className={`crm-conv-folder-button ${selectedFolder === folder.id ? "is-active" : ""}`}
                            type="button"
                            onClick={() => onFolderClick(folder.id)}
                        >
                            {folder.label}
                        </button>
                    ))}
                </div>
            </Dropdown>
            <Dropdown title="Phone">
                <div className="crm-conv-folder-list">
                    {phoneFolders.map((folder) => (
                        <button
                            key={folder.id}
                            className={`crm-conv-folder-button ${selectedFolder === folder.id ? "is-active" : ""}`}
                            type="button"
                            onClick={() => onFolderClick(folder.id)}
                        >
                            {folder.label}
                        </button>
                    ))}
                </div>
            </Dropdown>
        </div>
    );
}

export default ConversationFiltersPanel;
